// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__font-s-10____kC7X {
  font-size: 10px !important;
}

.Header-module__font-s-12___g9kGp {
  font-size: 12px !important;
}

.Header-module__font-s-13___PzlaZ {
  font-size: 13px !important;
}

.Header-module__font-s-14___hHsyG {
  font-size: 14px !important;
}

.Header-module__font-s-15___yuiQA {
  font-size: 15px !important;
}

.Header-module__font-s-16___otCyp {
  font-size: 16px !important;
}

.Header-module__font-s-18___LItU4 {
  font-size: 18px !important;
}

.Header-module__font-s-20___wBaO8 {
  font-size: 20px !important;
}

.Header-module__font-s-22___lq9CN {
  font-size: 22px !important;
}

.Header-module__font-s-28___yY47x {
  font-size: 28px !important;
}

.Header-module__font-w-400___W_zOu {
  font-weight: 400 !important;
}

.Header-module__font-w-500___oWX7w {
  font-weight: 500 !important;
}

.Header-module__font-w-600___tZoWS {
  font-weight: 600 !important;
}

.Header-module__font-w-700___vL7dt {
  font-weight: 700 !important;
}

.Header-module__p-5___EX0hf {
  padding: 5px !important;
}

.Header-module__p-12___mgZot {
  padding: 12px !important;
}

.Header-module__p-16___nT59O {
  padding: 16px !important;
}

.Header-module__p-30___UQrxW {
  padding: 30px !important;
}

.Header-module__p-b-0___qUf0g {
  padding-bottom: 0 !important;
}

.Header-module__p-b-5___LrBfe {
  padding-bottom: 5px !important;
}

.Header-module__p-b-10___owNRO {
  padding-bottom: 10px !important;
}

.Header-module__p-b-12___yjKfQ {
  padding-bottom: 12px !important;
}

.Header-module__p-b-16___jmzCZ {
  padding-bottom: 16px !important;
}

.Header-module__p-b-18___GVMMH {
  padding-bottom: 18px !important;
}

.Header-module__p-b-20___oYDCs {
  padding-bottom: 20px !important;
}

.Header-module__p-b-25___xgXi0 {
  padding-bottom: 25px !important;
}

.Header-module__p-b-30___ZDkH0 {
  padding-bottom: 30px !important;
}

.Header-module__p-b-50___jb316 {
  padding-bottom: 50px !important;
}

.Header-module__p-t-0___aUcu2 {
  padding-top: 0 !important;
}

.Header-module__p-t-12___E7RTL {
  padding-top: 12px !important;
}

.Header-module__p-t-16____s9fz {
  padding-top: 16px !important;
}

.Header-module__p-t-18___AXKSI {
  padding-top: 18px !important;
}

.Header-module__p-t-20___ivqAp {
  padding-top: 20px !important;
}

.Header-module__p-t-30___JHkvg {
  padding-top: 30px !important;
}

.Header-module__p-t-40___MtFnt {
  padding-top: 40px !important;
}

.Header-module__p-t-50___Vu73d {
  padding-top: 50px !important;
}

.Header-module__p-l-20___DM5ku {
  padding-left: 20px !important;
}

.Header-module__p-l-30___BUpvw {
  padding-left: 30px !important;
}

.Header-module__p-l-40___YbjwC {
  padding-left: 40px !important;
}

.Header-module__p-r-16___ghcnv {
  padding-right: 16px !important;
}

.Header-module__p-r-20___jKAwd {
  padding-right: 20px !important;
}

.Header-module__p-r-30___PqWwm {
  padding-right: 30px !important;
}

.Header-module__p-r-50___DFCWI {
  padding-right: 50px !important;
}

.Header-module__p-r-60___CaeLz {
  padding-right: 60px !important;
}

.Header-module__m-b-1___v1zKY {
  margin-bottom: 1px !important;
}

.Header-module__m-b-2___mKHUj {
  margin-bottom: 2px !important;
}

.Header-module__m-b-6___NTZBD {
  margin-bottom: 6px !important;
}

.Header-module__m-b-8___mzMQu {
  margin-bottom: 8px !important;
}

.Header-module__m-b-10___aMl1r {
  margin-bottom: 10px !important;
}

.Header-module__m-b-14___x9hxG {
  margin-bottom: 14px !important;
}

.Header-module__m-b-16___cWBo9 {
  margin-bottom: 16px !important;
}

.Header-module__m-b-20___AOtX2 {
  margin-bottom: 20px !important;
}

.Header-module__m-b-22___bOxJ3 {
  margin-bottom: 22px !important;
}

.Header-module__m-b-24___Bi9r3 {
  margin-bottom: 24px !important;
}

.Header-module__m-b-30___ibtW1 {
  margin-bottom: 30px !important;
}

.Header-module__m-b-32___HXY99 {
  margin-bottom: 32px !important;
}

.Header-module__m-b-40___SQpKZ {
  margin-bottom: 40px !important;
}

.Header-module__m-t-2___Nklvm {
  margin-top: 2px !important;
}

.Header-module__m-t-3___So3KQ {
  margin-top: 3px !important;
}

.Header-module__m-t-4___T36gZ {
  margin-top: 4px !important;
}

.Header-module__m-t-5___NUn81 {
  margin-top: 5px !important;
}

.Header-module__m-t-8___CjOyA {
  margin-top: 8px !important;
}

.Header-module__m-t-10___m8him {
  margin-top: 10px !important;
}

.Header-module__m-t-15___f0pIq {
  margin-top: 15px !important;
}

.Header-module__m-t-16___BUyF5 {
  margin-top: 16px !important;
}

.Header-module__m-t-20___MMiAK {
  margin-top: 20px !important;
}

.Header-module__m-t-22___F8iww {
  margin-top: 22px !important;
}

.Header-module__m-t-30___erNjm {
  margin-top: 30px !important;
}

.Header-module__m-t-32___mOdLi {
  margin-top: 32px !important;
}

.Header-module__m-l-auto___HG5TK {
  margin-left: auto !important;
}

.Header-module__m-l-4___oGxsA {
  margin-left: 4px !important;
}

.Header-module__m-l-5___AduAl {
  margin-left: 5px !important;
}

.Header-module__m-l-6___W8PiI {
  margin-left: 6px !important;
}

.Header-module__m-l-8___aRYyM {
  margin-left: 8px !important;
}

.Header-module__m-l-10___TixFr {
  margin-left: 10px !important;
}

.Header-module__m-l-16___LuC1v {
  margin-left: 16px !important;
}

.Header-module__m-l-20___SzjOs {
  margin-left: 20px !important;
}

.Header-module__m-l-24___bgTHX {
  margin-left: 24px !important;
}

.Header-module__m-l-30___aTRCm {
  margin-left: 30px !important;
}

.Header-module__m-l-35___vUnQN {
  margin-left: 35px !important;
}

.Header-module__m-l-40___VJ8rv {
  margin-left: 40px !important;
}

.Header-module__m-r-8___JpeGl {
  margin-right: 8px !important;
}

.Header-module__m-r-10___dPevl {
  margin-right: 10px !important;
}

.Header-module__m-r-16___tIn5h {
  margin-right: 16px !important;
}

.Header-module__m-r-20___ZeAmL {
  margin-right: 20px !important;
}

.Header-module__m-r-24___nTZYx {
  margin-right: 24px !important;
}

.Header-module__m-r-30___B7oPD {
  margin-right: 30px !important;
}

.Header-module__m-r-40___hln5c {
  margin-right: 40px !important;
}

.Header-module__border-r-3___MMN6J {
  border-radius: 3px !important;
}

.Header-module__border-r-4___oFfp2 {
  border-radius: 4px !important;
}

.Header-module__border-r-6___Y9zYN {
  border-radius: 6px !important;
}

.Header-module__border-r-10___e49RR {
  border-radius: 10px !important;
}

.Header-module__border-r-12___FP0_I {
  border-radius: 12px !important;
}

.Header-module__border-r-16___GC4M8 {
  border-radius: 16px !important;
}

.Header-module__border-r-50___YWuni {
  border-radius: 50% !important;
}

.Header-module__primary-border___dIbBP {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-b___lECTS {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-t___v7s_j {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-l___y2mvQ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__primary-border-r___RKHQy {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Header-module__secondary-border___SRH35 {
  border: 1px solid #637768;
}

.Header-module__secondary-border-b___v5od8 {
  border-bottom: 1px solid #637768;
}

.Header-module__secondary-border-t___chF1Y {
  border-top: 1px solid #637768;
}

.Header-module__secondary-border-l___Ycluc {
  border-left: 1px solid #637768;
}

.Header-module__secondary-border-r___Xz8Hc {
  border-right: 1px solid #637768;
}

.Header-module__gap-0___uqnKA {
  gap: 0 !important;
}

.Header-module__gap-2____Wmt6 {
  gap: 2px !important;
}

.Header-module__gap-4___gu29X {
  gap: 4px !important;
}

.Header-module__gap-5___TJ4BP {
  gap: 5px !important;
}

.Header-module__gap-6___xfSXG {
  gap: 6px !important;
}

.Header-module__gap-8___ohQ48 {
  gap: 8px !important;
}

.Header-module__gap-10___xP7OH {
  gap: 10px !important;
}

.Header-module__gap-12___RucHf {
  gap: 12px !important;
}

.Header-module__gap-14___tpfjx {
  gap: 14px !important;
}

.Header-module__gap-16___XAcKh {
  gap: 16px !important;
}

.Header-module__gap-18___lpW_m {
  gap: 18px !important;
}

.Header-module__gap-20___wYFGn {
  gap: 20px !important;
}

.Header-module__gap-24___QhCkX {
  gap: 24px !important;
}

.Header-module__gap-26___ECF21 {
  gap: 26px !important;
}

.Header-module__gap-30___QS3EV {
  gap: 30px !important;
}

.Header-module__gap-32___bAd9K {
  gap: 32px !important;
}

.Header-module__gap-40___wBa5X {
  gap: 40px !important;
}

.Header-module__gap-50___tXhK6 {
  gap: 50px !important;
}

.Header-module__flex-1___iox0m {
  flex: 1;
}

.Header-module__flex-none___DtXYY {
  flex: none !important;
}

.Header-module__flex-column___RM5SF {
  display: flex;
  flex-direction: column !important;
}

.Header-module__flex-row___x6PcH {
  display: flex;
  flex-direction: row !important;
}

.Header-module__vertically-centered___Fsg8i {
  display: flex;
  align-items: center !important;
}

.Header-module__horizontally-centered___QSZz0 {
  display: flex;
  justify-content: center !important;
}

.Header-module__horizontally-end___RI3Gp {
  display: flex;
  justify-content: end !important;
}

.Header-module__vertically-start___B4Q9U {
  display: flex;
  align-items: start !important;
}

.Header-module__space-between___CNwOO {
  display: flex;
  justify-content: space-between !important;
}

.Header-module__flex-wrap___SmfwW {
  flex-wrap: wrap !important;
}

.Header-module__height-100___sanNi {
  height: 100%;
}

.Header-module__width-50___E4hkg {
  width: 50% !important;
}

.Header-module__width-100___ivE_d {
  width: 100%;
}

.Header-module__cursor-pointer___zcZ53 {
  cursor: pointer;
}

.Header-module__cursor-not-allowed___aVQ4Q {
  cursor: not-allowed !important;
}

.Header-module__absolute-centered___wZHqE {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Header-module__absolute___mWlfh {
  position: absolute;
}

.Header-module__relative___YFJVI {
  position: relative;
}

.Header-module__fixed___M2UlK {
  position: fixed;
}

.Header-module__visible___T3NWp {
  opacity: 1;
}

.Header-module__invisible___oV9Ee {
  opacity: 0;
}

.Header-module__col-90___dEzQN {
  width: 90% !important;
}

.Header-module__col-auto___cTuLj {
  width: auto !important;
}

.Header-module__medical-tabs___rugbJ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Header-module__medical-table-new___oUUIn {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Header-module__medical-table-new___oUUIn:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Header-module__medical-table-new___oUUIn::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Header-module__medical-table-new___oUUIn::-webkit-scrollbar-track {
  display: none;
}
.Header-module__medical-table-new___oUUIn.Header-module__no-pagination___Xo4Wy {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Header-module__medical-table-new___oUUIn.Header-module__no-pagination___Xo4Wy:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Header-module__medical-table-new___oUUIn.Header-module__no-pagination___Xo4Wy::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Header-module__medical-table-new___oUUIn.Header-module__no-pagination___Xo4Wy::-webkit-scrollbar-track {
  display: none;
}

.Header-module__medical-table-empty___fWiSJ {
  padding: 14px 40px !important;
}

.Header-module__icon-btn___KouRH {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Header-module__search-icon___gI_VK {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Header-module__disable-select___X0Ka1 {
  user-select: none;
}

.Header-module__break-word___Dv_xY {
  word-break: break-word;
}

.Header-module__popup-clear-btn___POAIg {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Header-module__scroll-m-b-20___mOFEf {
  scroll-margin-bottom: 20px;
}

.Header-module__container___DGpAt {
  flex: 1;
  justify-content: space-between;
}
.Header-module__container___DGpAt .Header-module__title___OPIg3 {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 27px;
  color: #375844;
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/CGMOrdersFragment/components/OrderHistoryList/Header/Header.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,8BAAA;AA8pBF;AA5pBE;EEoBA,+BApBO;EAqBP,gBAFmD;EFjBjD,iBAAA;EACA,cAAA;EACA,OAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  justify-content: space-between;\n\n  .title {\n    @include get-font($roboto);\n    line-height: 27px;\n    color: get-color(greenNew, dark);\n    flex: 1;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Header-module__font-s-10____kC7X`,
	"fontS12": `Header-module__font-s-12___g9kGp`,
	"fontS13": `Header-module__font-s-13___PzlaZ`,
	"fontS14": `Header-module__font-s-14___hHsyG`,
	"fontS15": `Header-module__font-s-15___yuiQA`,
	"fontS16": `Header-module__font-s-16___otCyp`,
	"fontS18": `Header-module__font-s-18___LItU4`,
	"fontS20": `Header-module__font-s-20___wBaO8`,
	"fontS22": `Header-module__font-s-22___lq9CN`,
	"fontS28": `Header-module__font-s-28___yY47x`,
	"fontW400": `Header-module__font-w-400___W_zOu`,
	"fontW500": `Header-module__font-w-500___oWX7w`,
	"fontW600": `Header-module__font-w-600___tZoWS`,
	"fontW700": `Header-module__font-w-700___vL7dt`,
	"p5": `Header-module__p-5___EX0hf`,
	"p12": `Header-module__p-12___mgZot`,
	"p16": `Header-module__p-16___nT59O`,
	"p30": `Header-module__p-30___UQrxW`,
	"pB0": `Header-module__p-b-0___qUf0g`,
	"pB5": `Header-module__p-b-5___LrBfe`,
	"pB10": `Header-module__p-b-10___owNRO`,
	"pB12": `Header-module__p-b-12___yjKfQ`,
	"pB16": `Header-module__p-b-16___jmzCZ`,
	"pB18": `Header-module__p-b-18___GVMMH`,
	"pB20": `Header-module__p-b-20___oYDCs`,
	"pB25": `Header-module__p-b-25___xgXi0`,
	"pB30": `Header-module__p-b-30___ZDkH0`,
	"pB50": `Header-module__p-b-50___jb316`,
	"pT0": `Header-module__p-t-0___aUcu2`,
	"pT12": `Header-module__p-t-12___E7RTL`,
	"pT16": `Header-module__p-t-16____s9fz`,
	"pT18": `Header-module__p-t-18___AXKSI`,
	"pT20": `Header-module__p-t-20___ivqAp`,
	"pT30": `Header-module__p-t-30___JHkvg`,
	"pT40": `Header-module__p-t-40___MtFnt`,
	"pT50": `Header-module__p-t-50___Vu73d`,
	"pL20": `Header-module__p-l-20___DM5ku`,
	"pL30": `Header-module__p-l-30___BUpvw`,
	"pL40": `Header-module__p-l-40___YbjwC`,
	"pR16": `Header-module__p-r-16___ghcnv`,
	"pR20": `Header-module__p-r-20___jKAwd`,
	"pR30": `Header-module__p-r-30___PqWwm`,
	"pR50": `Header-module__p-r-50___DFCWI`,
	"pR60": `Header-module__p-r-60___CaeLz`,
	"mB1": `Header-module__m-b-1___v1zKY`,
	"mB2": `Header-module__m-b-2___mKHUj`,
	"mB6": `Header-module__m-b-6___NTZBD`,
	"mB8": `Header-module__m-b-8___mzMQu`,
	"mB10": `Header-module__m-b-10___aMl1r`,
	"mB14": `Header-module__m-b-14___x9hxG`,
	"mB16": `Header-module__m-b-16___cWBo9`,
	"mB20": `Header-module__m-b-20___AOtX2`,
	"mB22": `Header-module__m-b-22___bOxJ3`,
	"mB24": `Header-module__m-b-24___Bi9r3`,
	"mB30": `Header-module__m-b-30___ibtW1`,
	"mB32": `Header-module__m-b-32___HXY99`,
	"mB40": `Header-module__m-b-40___SQpKZ`,
	"mT2": `Header-module__m-t-2___Nklvm`,
	"mT3": `Header-module__m-t-3___So3KQ`,
	"mT4": `Header-module__m-t-4___T36gZ`,
	"mT5": `Header-module__m-t-5___NUn81`,
	"mT8": `Header-module__m-t-8___CjOyA`,
	"mT10": `Header-module__m-t-10___m8him`,
	"mT15": `Header-module__m-t-15___f0pIq`,
	"mT16": `Header-module__m-t-16___BUyF5`,
	"mT20": `Header-module__m-t-20___MMiAK`,
	"mT22": `Header-module__m-t-22___F8iww`,
	"mT30": `Header-module__m-t-30___erNjm`,
	"mT32": `Header-module__m-t-32___mOdLi`,
	"mLAuto": `Header-module__m-l-auto___HG5TK`,
	"mL4": `Header-module__m-l-4___oGxsA`,
	"mL5": `Header-module__m-l-5___AduAl`,
	"mL6": `Header-module__m-l-6___W8PiI`,
	"mL8": `Header-module__m-l-8___aRYyM`,
	"mL10": `Header-module__m-l-10___TixFr`,
	"mL16": `Header-module__m-l-16___LuC1v`,
	"mL20": `Header-module__m-l-20___SzjOs`,
	"mL24": `Header-module__m-l-24___bgTHX`,
	"mL30": `Header-module__m-l-30___aTRCm`,
	"mL35": `Header-module__m-l-35___vUnQN`,
	"mL40": `Header-module__m-l-40___VJ8rv`,
	"mR8": `Header-module__m-r-8___JpeGl`,
	"mR10": `Header-module__m-r-10___dPevl`,
	"mR16": `Header-module__m-r-16___tIn5h`,
	"mR20": `Header-module__m-r-20___ZeAmL`,
	"mR24": `Header-module__m-r-24___nTZYx`,
	"mR30": `Header-module__m-r-30___B7oPD`,
	"mR40": `Header-module__m-r-40___hln5c`,
	"borderR3": `Header-module__border-r-3___MMN6J`,
	"borderR4": `Header-module__border-r-4___oFfp2`,
	"borderR6": `Header-module__border-r-6___Y9zYN`,
	"borderR10": `Header-module__border-r-10___e49RR`,
	"borderR12": `Header-module__border-r-12___FP0_I`,
	"borderR16": `Header-module__border-r-16___GC4M8`,
	"borderR50": `Header-module__border-r-50___YWuni`,
	"primaryBorder": `Header-module__primary-border___dIbBP`,
	"primaryBorderB": `Header-module__primary-border-b___lECTS`,
	"primaryBorderT": `Header-module__primary-border-t___v7s_j`,
	"primaryBorderL": `Header-module__primary-border-l___y2mvQ`,
	"primaryBorderR": `Header-module__primary-border-r___RKHQy`,
	"secondaryBorder": `Header-module__secondary-border___SRH35`,
	"secondaryBorderB": `Header-module__secondary-border-b___v5od8`,
	"secondaryBorderT": `Header-module__secondary-border-t___chF1Y`,
	"secondaryBorderL": `Header-module__secondary-border-l___Ycluc`,
	"secondaryBorderR": `Header-module__secondary-border-r___Xz8Hc`,
	"gap0": `Header-module__gap-0___uqnKA`,
	"gap2": `Header-module__gap-2____Wmt6`,
	"gap4": `Header-module__gap-4___gu29X`,
	"gap5": `Header-module__gap-5___TJ4BP`,
	"gap6": `Header-module__gap-6___xfSXG`,
	"gap8": `Header-module__gap-8___ohQ48`,
	"gap10": `Header-module__gap-10___xP7OH`,
	"gap12": `Header-module__gap-12___RucHf`,
	"gap14": `Header-module__gap-14___tpfjx`,
	"gap16": `Header-module__gap-16___XAcKh`,
	"gap18": `Header-module__gap-18___lpW_m`,
	"gap20": `Header-module__gap-20___wYFGn`,
	"gap24": `Header-module__gap-24___QhCkX`,
	"gap26": `Header-module__gap-26___ECF21`,
	"gap30": `Header-module__gap-30___QS3EV`,
	"gap32": `Header-module__gap-32___bAd9K`,
	"gap40": `Header-module__gap-40___wBa5X`,
	"gap50": `Header-module__gap-50___tXhK6`,
	"flex1": `Header-module__flex-1___iox0m`,
	"flexNone": `Header-module__flex-none___DtXYY`,
	"flexColumn": `Header-module__flex-column___RM5SF`,
	"flexRow": `Header-module__flex-row___x6PcH`,
	"verticallyCentered": `Header-module__vertically-centered___Fsg8i`,
	"horizontallyCentered": `Header-module__horizontally-centered___QSZz0`,
	"horizontallyEnd": `Header-module__horizontally-end___RI3Gp`,
	"verticallyStart": `Header-module__vertically-start___B4Q9U`,
	"spaceBetween": `Header-module__space-between___CNwOO`,
	"flexWrap": `Header-module__flex-wrap___SmfwW`,
	"height100": `Header-module__height-100___sanNi`,
	"width50": `Header-module__width-50___E4hkg`,
	"width100": `Header-module__width-100___ivE_d`,
	"cursorPointer": `Header-module__cursor-pointer___zcZ53`,
	"cursorNotAllowed": `Header-module__cursor-not-allowed___aVQ4Q`,
	"absoluteCentered": `Header-module__absolute-centered___wZHqE`,
	"absolute": `Header-module__absolute___mWlfh`,
	"relative": `Header-module__relative___YFJVI`,
	"fixed": `Header-module__fixed___M2UlK`,
	"visible": `Header-module__visible___T3NWp`,
	"invisible": `Header-module__invisible___oV9Ee`,
	"col90": `Header-module__col-90___dEzQN`,
	"colAuto": `Header-module__col-auto___cTuLj`,
	"medicalTabs": `Header-module__medical-tabs___rugbJ`,
	"medicalTableNew": `Header-module__medical-table-new___oUUIn`,
	"noPagination": `Header-module__no-pagination___Xo4Wy`,
	"medicalTableEmpty": `Header-module__medical-table-empty___fWiSJ`,
	"iconBtn": `Header-module__icon-btn___KouRH`,
	"searchIcon": `Header-module__search-icon___gI_VK`,
	"disableSelect": `Header-module__disable-select___X0Ka1`,
	"breakWord": `Header-module__break-word___Dv_xY`,
	"popupClearBtn": `Header-module__popup-clear-btn___POAIg`,
	"scrollMB20": `Header-module__scroll-m-b-20___mOFEf`,
	"container": `Header-module__container___DGpAt`,
	"title": `Header-module__title___OPIg3`
};
module.exports = ___CSS_LOADER_EXPORT___;
